import React, { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";

const IoMdSearch = require("react-icons/io").IoMdSearch;
const FaPlus = require("react-icons/fa").FaPlus;

const Produk = () => {
  const [produkList, setProdukList] = useState<any[]>([]);
  const [categories, setCategories] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);

  const [search, setSearch] = useState("");
  const [discount, setDiscount] = useState("");
  const [categoryId, setCategoryId] = useState("");

  const [typingTimeout, setTypingTimeout] = useState<any>(null);

  const token = Cookies.get("token");

  const fetchProduk = async (page = 1) => {
    setLoading(true);

    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/produk`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          page,
          search,
          discount,
          category_id: categoryId,
        },
      });

      setProdukList(res.data.data);
      setCurrentPage(res.data.current_page);
      setLastPage(res.data.last_page);
    } catch (err) {
      console.error("Gagal ambil produk:", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchCategories = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/categories`);
      setCategories(res.data);
    } catch (err) {
      console.error("Gagal ambil kategori");
    }
  };

  useEffect(() => {
    fetchProduk();
    fetchCategories();
  }, []);

  useEffect(() => {
    fetchProduk(1);
  }, [discount, categoryId]);

  const handleSearchChange = (e: any) => {
    const value = e.target.value;
    setSearch(value);

    if (typingTimeout) clearTimeout(typingTimeout);

    const timeout = setTimeout(() => {
      fetchProduk(1);
    }, 500);

    setTypingTimeout(timeout);
  };

  const formatPrice = (price: any) => {
    return new Intl.NumberFormat("id-ID").format(price);
  };

  return (
    <div className="mt-7">
      {/* HEADER */}
      <div className="flex flex-col md:flex-row justify-between gap-4 mb-6">
        <h2 className="text-xl font-bold text-gray-800">Manajemen Produk</h2>

        <div className="flex flex-wrap gap-3">
          {/* SEARCH */}
          <div className="flex border rounded-lg overflow-hidden">
            <input type="text" placeholder="Cari produk..." value={search} onChange={handleSearchChange} className="px-3 py-2 outline-none" />
            <button className="bg-yellow-500 text-white px-4">
              <IoMdSearch />
            </button>
          </div>

          {/* FILTER DISCOUNT */}
          <select className="border rounded-lg px-3 py-2" value={discount} onChange={(e) => setDiscount(e.target.value)}>
            <option value="">Semua</option>
            <option value="1">Diskon</option>
          </select>

          {/* FILTER CATEGORY */}
          <select className="border rounded-lg px-3 py-2" value={categoryId} onChange={(e) => setCategoryId(e.target.value)}>
            <option value="">Semua Kategori</option>
            {categories.map((cat: any) => (
              <option key={cat.id} value={cat.id}>
                {cat.name}
              </option>
            ))}
          </select>

          {/* TAMBAH PRODUK */}
          <Link to="/dashboard/produk/tambah">
            <button className="flex items-center gap-2 bg-primary text-white px-4 py-2 rounded-lg hover:opacity-90">
              <FaPlus /> Produk
            </button>
          </Link>

          {/* TAMBAH KATEGORI */}
          <Link to="/dashboard/kategori/tambah">
            <button className="flex items-center gap-2 bg-black text-white px-4 py-2 rounded-lg">
              <FaPlus /> Kategori
            </button>
          </Link>
        </div>
      </div>

      {/* TABLE */}
      <div className="bg-white rounded-xl shadow border overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead className="bg-gray-100 text-gray-700">
            <tr>
              <th className="p-3 text-left">Produk</th>
              <th className="p-3 text-left">Kategori</th>
              <th className="p-3 text-left">Harga</th>
              <th className="p-3 text-left">Diskon</th>
              <th className="p-3 text-left">Stock</th>
              <th className="p-3 text-left">Status</th>
              <th className="p-3 text-left">Aksi</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan={7} className="text-center p-10">
                  <div className="animate-spin h-10 w-10 border-t-4 border-yellow-500 rounded-full mx-auto"></div>
                </td>
              </tr>
            ) : produkList.length > 0 ? (
              produkList.map((item: any) => (
                <tr key={item.id} className="border-t hover:bg-gray-50">
                  {/* PRODUK */}
                  <td className="p-3 flex items-center gap-3">
                    <img src={`${process.env.REACT_APP_STORAGE_URL}/products/${item.images?.[0]?.image}`} className="w-14 h-14 rounded object-cover" alt="" />

                    <div>
                      <p className="font-semibold">{item.name}</p>
                      <p className="text-xs text-gray-500">{item.product_code}</p>
                    </div>
                  </td>

                  {/* CATEGORY */}
                  <td className="p-3">{item.category?.name}</td>

                  {/* PRICE */}
                  <td className="p-3 font-medium">Rp {formatPrice(item.price)}</td>

                  {/* DISCOUNT */}
                  <td className="p-3">{item.discount ? <span className="bg-red-100 text-red-600 px-2 py-1 rounded text-xs">{item.discount}%</span> : "-"}</td>

                  {/* STOCK */}
                  <td className="p-3">{item.stock}</td>

                  {/* STATUS */}
                  <td className="p-3">
                    {item.status === "aktif" ? <span className="bg-green-100 text-green-600 px-2 py-1 rounded text-xs">Aktif</span> : <span className="bg-gray-200 text-gray-600 px-2 py-1 rounded text-xs">Nonaktif</span>}
                  </td>

                  {/* AKSI */}
                  <td className="p-3">
                    <Link to={`/dashboard/produk/${item.id}`} className="text-blue-600 hover:underline">
                      Detail
                    </Link>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={7} className="text-center p-10">
                  Produk tidak tersedia
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* PAGINATION */}
      <div className="flex justify-end items-center gap-4 mt-5">
        <button className="px-4 py-2 bg-gray-200 rounded disabled:opacity-40" disabled={currentPage === 1} onClick={() => fetchProduk(currentPage - 1)}>
          Prev
        </button>

        <span>
          Halaman {currentPage} dari {lastPage}
        </span>

        <button className="px-4 py-2 bg-gray-200 rounded disabled:opacity-40" disabled={currentPage === lastPage} onClick={() => fetchProduk(currentPage + 1)}>
          Next
        </button>
      </div>
    </div>
  );
};

export default Produk;
